<div>
  <app-lista-dados
    [upTitulo]="'Lista de Formas de Pagamento'"
    [upIcone]="'payment'"
    [upCor]="'3F51B5'"
    [upDados]="formasPagamento"
    [upColunas]="colunasListaDados"
    [upCarregando]="!!subscription"
    [upHabilitaEditarLinha]="true"
    [upLargura]="1"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    (ueSalvarLinha)="onSalvarLinha($event)"
    (ueBotaoExcluir)="onDelete($event)">
  </app-lista-dados>
</div>